import { NumberFormatter as NF } from "~/utils/NumberFormatter";

function escapeRegExp(str: string) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
}

const tSeparator = escapeRegExp(NF.getThousandSeparator());
const dSeparator = escapeRegExp(NF.getDecimalSeparator());

export const VALID_INPUT_NUMBER = new RegExp(`^-?[\\d${tSeparator}]*${dSeparator}?\\d*$`);
